import * as _ from "lodash";
import { createSelector } from "reselect";
//-- Selector
const mapLeadItems = (items) => {
    let temp = [];
    if (items) {
        temp = items;
    }
    return temp;
};
const stateReportSelector = (state) => state.reports.officeReports.agents;
export const reportSelector = createSelector(stateReportSelector, (report) => {
    if (!report) {
        return {
            isFetching: true,
            reportData: null
        };
    }
    let reportClone = _.cloneDeep(report);
    return {
        isFetching: reportClone.isFetching,
        reportData: {
            officeId: reportClone.officeId,
            officeName: reportClone.officeName,
            startDate: reportClone.startDate,
            endDate: reportClone.endDate,
            items: mapLeadItems(reportClone.items)
        }
    };
});
export default reportSelector;
